export default getRenamedImports;

function getRenamedImports(mod) {
	var renamed = [];

	mod.imports.forEach(function (x) {
		if (x.specifiers) {
			x.specifiers.forEach(function (s) {
				if (s.name !== s.as && ! ~renamed.indexOf(s.name)) {
					renamed.push(s.name);
				}
			});
		}
	});

	return renamed;
}
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/bundler/combine/getRenamedImports.js.01-babel.map